import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-semibold mb-2 text-center lg:text-left" }, "Contacto", -1)
const _hoisted_2 = { class: "flex flex-col sm:flex-row justify-between space-y-10 sm:space-y-0" }
const _hoisted_3 = { class: "w-full sm:w-1/2" }
const _hoisted_4 = { class: "flex flex-col space-y-5 text-center sm:text-left" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Imperio de Metal S.A de C.V", -1)
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex" }

import ContactForm from "@/components/base/ContactForm.vue";
import Call from "@vicons/ionicons5/Call";
import Mail from "@vicons/ionicons5/Mail";

export default /*#__PURE__*/_defineComponent({
  __name: 'ContactComponent',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ContactForm)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("span", _hoisted_6, [
          _createVNode(_unref(Call), { class: "w-6 mr-4" }),
          _createTextVNode(" +52 55 7467 4901 ")
        ]),
        _createElementVNode("span", _hoisted_7, [
          _createVNode(_unref(Mail), { class: "w-6 mr-4" }),
          _createTextVNode(" administracion@imperiodemetal.com.mx ")
        ])
      ])
    ])
  ], 64))
}
}

})